<template>
<div class="">

   <div class="yo-fixed-top el-container" style="top:132px;z-index:1001;">
        <div class="row yo-bg-color-primary" style="">
            <div class="col s6 m8 yo-bg-color-primary"><el-input class="no-border" :placeholder="'Cerca il paziente'" prefix-icon="el-icon-search" v-model="$centro.pazienteCerca" style="none"> <!-- @click="handleIconClick" --></el-input></div>
            
            <div class="col s2 m1 yo-bg-color-primary"><el-select class="no-border" v-model="$centro.pazienteAnno" filterable placeholder="Select"><el-option v-for="item in anni" :key="item.value" :label="item.label" :value="item.value"></el-option></el-select></div>

            <div class="col s4 m3 yo-bg-color-primary white yo-text-n " style="padding:12px 0 12px 12px;" v-if="numitems>0">Trovati {{numitems}} contatti<span v-if="numitems>1000">, vengono visualizzati solo i primi 100 pazienti</span> {{$centro.pazienteCerca}}</div>
            <div class="col s4 m3 yo-bg-color-primary white yo-text-n " style="padding:12px 0 12px 12px;" v-if="numitems<1">Nessun paziente trovato</div>
        </div>
    </div>

    
    <div style="padding-top:14px;padding-bottom:24px;">
        <!-- TIPO: {{tipo}}<br />TOPIC: {{topic}}<br />ABSTRACT: {{$abstracts.data.length}} -->
		  <!--
        <el-collapse accordion>
        <elCerca v-for="item in filtrati" :item="item" v-bind:key="item.id"></elCerca> 
		  </el-collapse>
        -->

      <div v-if="$centro._struttura.von>0 && $centro._errorVonNumber.length>0" style="border:2px solid #F73D3D;padding:6px;">
      <div class="red yo-text-bold">ATTENZIONE NUMERI VON DUPLICATI</div>
        Abbiamo notato che hai assegnato lo stesso numero VON a più bambini, ecco elenco:
        <ul>
      <li v-for="item in $centro._errorVonNumber" v-bind:key="item.vonnumber">{{item.vonnumber}} ({{item.totale}})</li>
        </ul>
        Ti preghiamo di correggere.
      </div>



   <el-table :data="filtrati" :height="$teras.app.height-212-54-54-24" style="width: 100%">
      <el-table-column type="expand">
         <template slot-scope="props">
            <elDetail :item="props.row"></elDetail>
         </template>
      </el-table-column>
      <el-table-column prop="ncartellaclinica" label="N.CARTELLA" width="140" :sortable="true" :sort-method="sortcartella">
         <template slot-scope="scope">{{scope.row.datanascita | data('YYYY')}}-{{scope.row.ncartellaclinica | zeropad(6)}}</template>
      </el-table-column>
      <el-table-column v-if="$centro._struttura.von>0" prop="vonnumber" label="N.VON" width="90" :sortable="true" :sort-method="sortvon" >
         <template slot-scope="scope"><span v-if="scope.row.vonnumber>0" :class="(scope.row.vonil!='0000-00-00 00:00:00') ? 'green':''">{{scope.row.vonnumber | zeropad(6)}}</span><span v-else>&#160;</span></template>
      </el-table-column>
      <el-table-column prop="datanascita" label="NATO IL" width="110" sortable :formatter="datanascitaCol"></el-table-column>

      <el-table-column prop="gaweeks" label="EG" width="68" :sortable="true" :sort-method="sorteta" align="right">
         <template slot-scope="scope">{{scope.row.gaweeks}}+{{scope.row.gadays}}</template>
      </el-table-column>

      <el-table-column prop="bwgt" label="PESO" width="84" :sortable="true" align="right">
         <template slot-scope="scope" class="yo-align-right">{{scope.row.bwgt}}</template>
      </el-table-column>

      <el-table-column prop="cognome" label="NOMINATIVO" sortable>
         <template slot-scope="scope">{{ scope.row.cognome }} {{ scope.row.nome }}</template>
      </el-table-column>

      <el-table-column prop="nr_numero" label="STATUS" width="120" sortable>
         <template slot-scope="scope">
            <div class="red yo-text-bold yo-align-left" v-if="scope.row.nr_numero>10" style="">{{scope.row.nr_numero}}&#160;&#160;<i class="material-icons" style="float:left;margin-right:12px;line-height:24px;">error</i></div>
            <div class="tree_poppy yo-text-bold yo-align-left" v-if="scope.row.nr_numero>0 && scope.row.nr_numero<11" style="">{{scope.row.nr_numero}}&#160;&#160;<i class="material-icons" style="float:left;margin-right:12px;line-height:24px;">warning</i></div>
            <div class="grees yo-text-bold yo-align-center" v-if="scope.row.nr_numero==0" style="">
               <i class="material-icons green" style="float:left;margin-right:12px;line-height:24px;">done</i>
               <i v-if="scope.row.chiusoil!='0000-00-00 00:00:00'" class="material-icons green" style="float:left;margin-right:12px;line-height:24px;">send</i>
            </div>
      
            
         </template>
      </el-table-column>

            


  </el-table>


    </div>


</div>
</template>

<script>
import elCerca from './Paziente-elenco.vue'
import elDetail from './Paziente-detail.vue'
export default {
   components: {
      elCerca
      ,elDetail
   }
   ,name: 'Cerca'
   ,data () {
      return {
         numitems: 0
         ,anni: [
            {value: '2019',label: '2019'}
            ,{value: '2020',label: '2020'}
            ,{value: '2021',label: '2021'}
            ,{value: '2022',label: '2022'}
            ,{value: '2023',label: '2023'}
            ,{value: '2024',label: '2024'}
            ,{value: '2025',label: '2025'}
         ]
      }
   },
  created () {
      this.$teras.event.on('variabile-saved', () => {
        //this.$axios.query('fetchAll',`SELECT * FROM variabile WHERE 1 ORDER BY nome`,{},this.$teras,'_contatto')

      })
  }
   ,methods:{
      datanascitaCol(row, column, cellValue, index){
         return this.$moment(cellValue).format('DD-MM-YYYY')
      },
      sortcartella(a,b){
         let esito = 0
         let avalue = this.$moment(a.datanascita).format('YYYY')*1000000000000+a.ncartellaclinica
         let bvalue = this.$moment(b.datanascita).format('YYYY')*1000000000000+b.ncartellaclinica
         if(avalue>bvalue)
            esito = 1
         if(bvalue>avalue)
            esito = -1
         return esito
      },
      sortvon(a,b){
         let esito = 0
         let avalue = 1000000000000+a.vonnumber
         let bvalue = 1000000000000+b.vonnumber
         if(a.vonnumber==-127)
            avalue = 1000000000000+999999
         if(b.vonnumber==-127)
            bvalue = 1000000000000+999999
         if(avalue>bvalue)
            esito = 1
         if(bvalue>avalue)
            esito = -1
         return esito
      },
      sorteta(a,b){
         let esito = 0
         let avalue = a.gaweeks*7+a.gadays
         let bvalue = b.gaweeks*7+b.gadays
         if(avalue>bvalue)
            esito = 1
         if(bvalue>avalue)
            esito = -1
         return esito
      },
      variabileNew(){
         this.$router.push('/domanda-edit')
      }
   }
   ,computed: {
      filtrati: function () {
      this.numitems = this.$centro._paziente.length

      console.log("TROVATI "+this.numitems+" PAZIENTI ora filtro per: "+this.$centro.pazienteCerca)
      
      if(this.numitems==0)
         return {}

      //if(this.$centro.pazienteCerca=='' )
           //return this.$centro._paziente.slice(0, 10000)
	 
		var words = this.$centro.pazienteCerca.toString().split('+')
		 
      
		var isFilter = []
		
      for (let item of this.$centro._paziente){
			var trovati = 0
			for (let word of words){
            if(
            item.datanascita.substring(0, 4) == this.$centro.pazienteAnno
            &&
            (
            item.nome.toString().toLowerCase().indexOf(word.toLowerCase()) > -1 
            || 
            item.cognome.toString().toLowerCase().indexOf(word.toLowerCase()) > -1 
            || 
            item.ncartellaclinica.toString().toLowerCase().indexOf(word.toLowerCase()) > -1
            || 
            item.id.toString().toLowerCase().indexOf(word.toLowerCase()) > -1
            )

            ) 
				trovati++
			}

			if(trovati==words.length)
				isFilter.push(item)
/*
         if(   
         (item.id>0) 
         && (
            item.nome.toString().toLowerCase().indexOf(this.$teras.contattoTermine.toLowerCase()) > -1 
            || 
            item.cognome.toString().toLowerCase().indexOf(this.$teras.contattoTermine.toLowerCase()) > -1 
            || 
            item.citta.toString().toLowerCase().indexOf(this.$teras.contattoTermine.toLowerCase()) > -1
            )
         )
         isFilter.push(item)
*/         

      }
      this.numitems = isFilter.length




      return (isFilter.length>10000) ? isFilter.slice(0, 10000) : isFilter
      
      }
   }
}

    
</script>

